import React from 'react'
import { Row, Col, Input, Button, Space } from 'antd'
import { SyncOutlined, PlusOutlined } from '@ant-design/icons'

const { Search } = Input

const SearchAndActions = ({ onSearch, onRefresh, onNewPatient, loading }) => {
  return (
    <Row style={{ marginTop: 16, marginBottom: 16 }}>
      <Col span={12}>
        <Search
          placeholder='Search by name, surname, full name, ID number, or exact billing ID'
          onSearch={onSearch}
          style={{ width: 450 }}
          allowClear
        />
      </Col>
      <Col span={12} style={{ textAlign: 'right' }}>
        <Space>
          <Button icon={<SyncOutlined />} onClick={onRefresh} loading={loading}>
            Refresh
          </Button>
          <Button type='primary' icon={<PlusOutlined />} onClick={onNewPatient}>
            New Patient
          </Button>
        </Space>
      </Col>
    </Row>
  )
}

export default SearchAndActions
